export default "__VITE_ASSET__C8MJWRLs__"